module.exports = __webpack_public_path__ + "img/circle-img-mobile.912ede4a.svg";